module.exports = __webpack_public_path__ + "static/media/store.5cdb3e51.svg";